import { Link } from "react-router-dom";
import styles from './Admin.module.css';

const Admin = () => {
    return (
        <section className={styles.admin}>
            <h1>Administration</h1>
            <h3>Questions</h3>
            <Link className={styles.block} to="/questions">All questions</Link>
            <Link className={styles.block} to="/matrix/new">Create new <strong>matrix</strong> question</Link>
            <Link className={styles.block} to="/multiplechoicequestion/new">Create new <strong>multiple-choice</strong> question</Link>
            <Link className={styles.block} to="/textquestion/new">Create new <strong>text</strong> question</Link>
            <Link className={styles.block} to="/numericquestion/new">Create new <strong>numeric</strong> question</Link>
            <Link className={styles.block} to="/constantsumquestion/new">Create new <strong>constant sum</strong> question</Link>
            <h3>Surveys</h3>
            <Link className={styles.block} to="/surveys">All surveys</Link>
            <Link className={styles.block} to="/survey/new">Create new survey</Link>
            <h3>Insights categories</h3>
            <Link className={styles.block} to="/insightscategories">All Insights categories</Link>
            <Link className={styles.block} to="/insightscategory/new">Create new Insights category</Link>
            <h3>Users</h3>
            <Link className={styles.block} to="/users">Users</Link>

        </section>
    )
}

export default Admin
